import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper, RowHelper } from "util/TableHelper";
import PosCollectionTransactionTableFilter from "../Filters/PosCollectionTransactionTableFilter";
import B2bPosCollectionSendReceiptForm from "../Forms/B2bPosCollectionSendReceiptForm";
import moment from "moment";
import config from "../../util/ApiforContext";
import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  Modal,
  Popconfirm,
  message,
  Button,
} from "antd";
import {
  BarsOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  FilePdfOutlined,
  DeleteOutlined,
  WarningOutlined,
  FileExcelOutlined,
  UpSquareOutlined,
} from "@ant-design/icons";
import { odata } from "../Filters/Helper";
import Iframe from "react-iframe";
import PosCollectionTransactionRefundModal from "./PosCollectionTransactionRefundModal";
import PosCollectionTransactionCancelModal from "./PosCollectionTransactionCancelModal";
import PosCollectionTransactionCompleteProvisionModal from "./PosCollectionTransactionCompleteProvisionModal";

const userId = localStorage.getItem("userId");
const PosCollectionTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [receiptModalVisible, setReceiptModalVisible] = useState();
  const [isReceiptMailSend, setIsReceiptMailSend] = useState();

  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [sendReceiptModal, setSendReceiptModal] = useState({
    visible: false,
    data: null,
  });
  const [order, setOrder] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [canPosCancelBankIdList, setCanPosCancelBankIdList] = useState([]);
  const [canPosRefundBankIdList, setCanPosRefundBankIdList] = useState([]);
  const [
    canPosCompleteProvisionBankIdList,
    setCanPosCompleteProvisionBankIdList,
  ] = useState([]);
  const [pdfUrl, setPdfUrl] = useState("");
  const [allowCancel, setAllowCancel] = useState(false);
  const [
    posCollectionTransactionRefundModal,
    setPosCollectionTransactionRefundModal,
  ] = useState({
    visible: false,
    data: null,
  });
  const [
    posCollectionTransactionCancelModal,
    setPosCollectionTransactionCancelModal,
  ] = useState({
    visible: false,
    data: null,
  });

  const [receiptPdfEnabled, setReceiptPdfEnabled] = useState(false);
  const [useAdditionalInformation, setUseAdditionalInformation] =
    useState(false);
  const [
    posCollectionTransactionCompleteProvisionModal,
    setPosCollectionTransactionCompleteProvisionModal,
  ] = useState({
    visible: false,
    data: null,
  });

  const [allowCompleteProvision, setAllowCompleteProvision] = useState(false);

  const [isUseB2BCurrencyExChange, setIsUseB2BCurrencyExChange] =
    useState(false);

  const [
    isUseB2BUnsuccessfulTransactionReceipt,
    setIsUseB2BUnsuccessfulTransactionReceipt,
  ] = useState(false);

  const [
    shouldShowIsCommissionIncludedColumn,
    setShouldShowIsCommissionIncludedColumn,
  ] = useState(false);

  useEffect(() => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setUseAdditionalInformation(
          response.isPosTransactionUseAdditionalField
        );
        setReceiptPdfEnabled(response.paramReceiptPdfEnabled);
        setIsUseB2BCurrencyExChange(response.isUseB2BCurrencyExChange);
        setIsUseB2BUnsuccessfulTransactionReceipt(
          response.isUseB2BUnsuccessfulTransactionReceipt
        );
      }
    });
  }, []);

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setIsReceiptMailSend(response.data.isReceiptMailSend);
        }
      }
    );

    RequestHandler.get(`/user/IsAdmin?userId=${userId}`).then((response) => {
      setIsAdmin(response);
    });
    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/PosCollectionTransaction?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
        setShouldShowIsCommissionIncludedColumn(
          response.value.some((row) => row.isCommissionIncluded === true)
        );
      }
    });
    RequestHandler.get(`/Bank`).then((response) => {
      if (Array.isArray(response.value)) {
        let supportPosCancelList = [];
        let supportPosRefundList = [];
        let completeProvisionList = [];

        response.value.map((item) => {
          if (item.isSupportPosCancel) {
            supportPosCancelList.push(item.id);
          }
          if (item.isSupportPosRefund) {
            supportPosRefundList.push(item.id);
          }
          if (item.isSupportPosPreAuth) {
            completeProvisionList.push(item.id);
          }
        });
        setCanPosCancelBankIdList(supportPosCancelList);
        setCanPosRefundBankIdList(supportPosRefundList);
        setCanPosCompleteProvisionBankIdList(completeProvisionList);
      }
    });

    RequestHandler.get("/TenantUser/IsAllowB2bCancel").then((response) => {
      setAllowCancel(response);
    });

    RequestHandler.get("/TenantUser/IsAllowB2bCompleteProvision").then(
      (response) => {
        setAllowCompleteProvision(response);
      }
    );
  };

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const setCancelPosTransaction = (row) => {
    if (row.isCanRefund) {
      setPosCollectionTransactionRefundModal({
        data: row,
        visible: true,
      });
      return;
    }
    if (row.isCanCancel) {
      setPosCollectionTransactionCancelModal({
        data: row,
        visible: true,
      });
      return;
    }
  };

  const setCompleteProvision = (row) => {
    setPosCollectionTransactionCompleteProvisionModal({
      data: row,
      visible: true,
    });
    return;
  };

  const refundRequestChangeStatus = (id, status) => {
    RequestHandler.post(
      `/PosCollectionTransaction/ChangeRefundRequestStatus/${id}?status=${status}`,
      null,
      false
    ).then((response) => {
      getTableData();
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onClickSendReceipt = (id) => {
    setSendReceiptModal({ visible: true, data: { id } });
  };
  const onClickShowReceipt = (id, state) => {
    const hideMessage = message.loading("Pdf açılyor...", 0);
    RequestHandler.get(
      `/PosCollectionTransaction/DownloadPdfReceiptColumnsWithDoc?id=${id}&state=${state}`,
      undefined,
      { rawResponse: true }
    ).then((response) => {
      hideMessage();
      setPdfUrl(response.data);
      setTimeout(() => {
        setReceiptModalVisible(true);
      }, 1000);
    });
  };

  const handleOkReceipt = () => {
    setPdfUrl("");
    setReceiptModalVisible(false);
  };
  const handleCancelReceipt = () => {
    setPdfUrl("");
    setReceiptModalVisible(false);
  };
  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      `/PosCollectionTransaction/ExportExcel`,
      {
        query: getFilterQuery(),
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${
            config.apiUrl
          }/PosCollectionTransaction/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const renderCommissionRate = (data, isCommissionIncluded) => {
    return data || data === 0 ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          marginLeft: "10px",
        }}
      >
        {ColumnHelper.renderDecimal(data)}
        {isCommissionIncluded && (
          <Tooltip
            title={
              <span
                dangerouslySetInnerHTML={{
                  __html: `
          <p>
            <strong>KTD (Komisyon Tutara Dahil) :</strong>
            <ul>
              <li>İşlem komisyon tutarı, tuşlanan tutarın içine dahil edilmiştir.</li>
            </ul>
          </p>
        `,
                }}
              />
            }
          >
            <CheckCircleOutlined style={{ color: "#1890ff" }} />
          </Tooltip>
        )}
      </div>
    ) : (
      "-"
    );
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: 150,
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Bayi Kodu",
      dataIndex: "firmCode",
      render: (data) => (data ? data : "-"),
    },
    {
      title: "İşlemi Yapan",
      dataIndex: "addUserName",
    },
    {
      title: "Ünvan",
      dataIndex: "firmName",
      render: (data, row) =>
        row.firmCode
          ? row.subFirmId
            ? data + " - " + "( " + row.subFirmName + " )"
            : data
          : row.customerInformation,
    },
    {
      title: "Tutar",
      dataIndex: "netAmount",
      key: "netAmount",
      sorter: true,
      render: (data) => (data === null ? "" : ColumnHelper.renderDecimal(data)),
    },
    {
      title: "Komisyon Tutarı",
      dataIndex: "commissionAmount",
      key: "commissionAmount",
      sorter: true,
      render: (data) => (data === null ? "" : ColumnHelper.renderDecimal(data)),
    },
    {
      title: "Toplam Tutar",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
      render: (data, record) =>
        renderCommissionRate(data, record?.isCommissionIncluded),
      align: "right",
    },
    shouldShowIsCommissionIncludedColumn && {
      title: "Net Tutar",
      dataIndex: "remainingNetAmountIncludingCommission",
      key: "remainingNetAmountIncludingCommission",
      sorter: true,
      render: (data) => (data === null ? "" : ColumnHelper.renderDecimal(data)),
      align: "right",
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Komisyon Oranı",
      dataIndex: "commissionRate",
      key: "commissionRate",
      sorter: true,
      render: (data) => (data === null ? "" : ColumnHelper.renderDecimal(data)),
    },
    {
      title: "Taksit Sayısı",
      dataIndex: "installmentCount",
    },
    {
      title: "İşlem Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      sorter: true,
      align: "center",
      render: (data) => moment(data).format("DD.MM.YYYY HH:mm"),
    },
    {
      title: "Onay Kodu",
      dataIndex: "authCode",
    },

    {
      title: "İşlem Sonucu",
      dataIndex: "success",
      align: "center",
      render: (data, row) => {
        if (row.isCancel || row.isRefund || row.isPartialRefund) {
          return (
            <Tooltip title={row.message}>
              <WarningOutlined
                style={
                  row.isCancel
                    ? { color: "red", fontSize: "130%" }
                    : { color: "orange", fontSize: "130%" }
                }
              />
            </Tooltip>
          );
        } else {
          if (data === null) {
            return (
              <Tooltip title={row.message}>
                <ClockCircleOutlined
                  style={{ color: "orange", fontSize: "130%" }}
                />
              </Tooltip>
            );
          }

          if (row.isPreAuth && row.isPreAuthSuccess && !row.success) {
            return (
              <Tooltip title={row.message}>
                <CheckCircleOutlined
                  style={{ color: "purple", fontSize: "130%" }}
                />
              </Tooltip>
            );
          }

          return data ? (
            <Tooltip title={row.message}>
              <CheckCircleOutlined
                style={{ color: "green", fontSize: "130%" }}
              />
            </Tooltip>
          ) : (
            <Tooltip title={row.message}>
              <CloseCircleOutlined style={{ color: "red", fontSize: "130%" }} />
            </Tooltip>
          );
        }
      },
    },
    allowCancel
      ? {
          title: "İptal/İade",
          dataIndex: "orderId",
          align: "center",
          render: (data, row) => {
            if (
              (row.isCanCancel || row.isCanRefund) &&
              row.success &&
              (canPosCancelBankIdList.includes(row.bankId) ||
                canPosRefundBankIdList.includes(row.bankId))
            ) {
              if (row.orderId !== null) {
                return (
                  <Popconfirm
                    title={
                      row.cancelRefundRequest == 0
                        ? "İşlemin İptal/İade talebi gelmiştir, işlemi İptal/İade etmek istiyor musunuz?"
                        : row.isCanCancel
                        ? "İptal etmek istiyor musunuz?"
                        : "Bu işlem gün içinde gerçekleşmediğinden iade işlemi yapılacaktır. Onaylıyor musunuz?"
                    }
                    okText="Evet"
                    cancelText="Hayır"
                    onConfirm={() => setCancelPosTransaction(row)}
                    onCancel={() => {
                      if (row.cancelRefundRequest == 0) {
                        refundRequestChangeStatus(row.id, 2);
                      }
                    }}
                  >
                    <DeleteOutlined
                      style={{ color: "red", fontSize: "130%" }}
                    />
                  </Popconfirm>
                );
              } else {
                return (
                  <Tooltip title={"Bu ödeme iptal edilemez."}>
                    <DeleteOutlined style={{ fontSize: "130%" }} disabled />
                  </Tooltip>
                );
              }
            } else if (!row.isCanCancel && !row.isCanRefund) {
              return (
                <Tooltip
                  title={
                    "Ödeme tarihinden itibaren 1 gün geçen ödemeler iptal edilemez."
                  }
                >
                  <DeleteOutlined
                    style={{ fontSize: "130%", opacity: "0.3" }}
                    disabled
                  />
                </Tooltip>
              );
            } else if (
              row.isPreAuthSuccess &&
              !row.success &&
              !row.isCancel &&
              !row.isRefund &&
              !row.isPartialRefund
            ) {
              if (row.orderId !== null) {
                return (
                  <Popconfirm
                    title={
                      row.cancelRefundRequest == 0
                        ? "İşlemin İptal talebi gelmiştir, işlemi İptal etmek istiyor musunuz?"
                        : row.isCanCancel
                        ? "İptal etmek istiyor musunuz?"
                        : "Bu işlem gün içinde gerçekleşmediğinden iade işlemi yapılacaktır. Onaylıyor musunuz?"
                    }
                    okText="Evet"
                    cancelText="Hayır"
                    onConfirm={() => setCancelPosTransaction(row)}
                    onCancel={() => {
                      if (row.cancelRefundRequest == 0) {
                        refundRequestChangeStatus(row.id, 2);
                      }
                    }}
                  >
                    <DeleteOutlined
                      style={{ color: "red", fontSize: "130%" }}
                    />
                  </Popconfirm>
                );
              } else {
                return (
                  <Tooltip title={"Bu ödeme iptal edilemez."}>
                    <DeleteOutlined style={{ fontSize: "130%" }} disabled />
                  </Tooltip>
                );
              }
            } else {
              return (
                <Tooltip title={"Bu ödeme iptal edilemez."}>
                  <DeleteOutlined
                    style={{ fontSize: "130%", opacity: "0.3" }}
                    disabled
                  />
                </Tooltip>
              );
            }
          },
        }
      : {},

    allowCompleteProvision
      ? {
          title: "Provizyon Kapama",
          dataIndex: "orderId",
          align: "center",
          render: (data, row) => {
            if (
              row.isPreAuth &&
              row.isPreAuthSuccess &&
              !row.success &&
              !row.isCancel &&
              !row.isRefund &&
              !row.isPartialRefund &&
              canPosCompleteProvisionBankIdList.includes(row.bankId)
            ) {
              if (row.orderId !== null) {
                return (
                  <Popconfirm
                    title={
                      "Bu işlem için provizyon kapama yapmak istiyor musunuz?"
                    }
                    okText="Evet"
                    cancelText="Hayır"
                    onConfirm={() => setCompleteProvision(row)}
                    onCancel={() => {
                      setPosCollectionTransactionCompleteProvisionModal({
                        visible: false,
                        data: null,
                      });
                    }}
                  >
                    <UpSquareOutlined
                      style={{ color: "purple", fontSize: "130%" }}
                    />
                  </Popconfirm>
                );
              } else {
                return (
                  <Tooltip title={"Bu işlemde provizyon kapama yapılamaz."}>
                    <DeleteOutlined style={{ fontSize: "130%" }} disabled />
                  </Tooltip>
                );
              }
            }
          },
        }
      : {},

    {
      title: "Provizyon Kapama Tutarı",
      dataIndex: "completedProvisionAmount",
      key: "completedProvisionAmount",
      render: (data) => (data === null ? "" : ColumnHelper.renderDecimal(data)),
    },
    {
      title: "Erp Kodu",
      dataIndex: "documentNumber",
    },
    {
      title: "İşlem Dekontu",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        const receiptAvailableBankIds = [889, 893];
        if (
          row.success &&
          receiptAvailableBankIds.includes(row.bankId) &&
          !receiptPdfEnabled
        ) {
          return (
            <a onClick={() => onClickSendReceipt(data)}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else if (
          (row.success ||
            row.isCancel ||
            row.isRefund ||
            row.isPartialRefund) &&
          !isReceiptMailSend
        ) {
          return (
            <a onClick={() => onClickShowReceipt(data, "success")}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else if (
          (row.success ||
            row.isCancel ||
            row.isRefund ||
            row.isPartialRefund) &&
          isReceiptMailSend
        ) {
          return (
            <a onClick={() => onClickSendReceipt(data, "success")}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else if (
          row.success === false &&
          isUseB2BUnsuccessfulTransactionReceipt
        ) {
          return (
            <a onClick={() => onClickShowReceipt(data, "unsuccessful")}>
              <FilePdfOutlined style={{ color: "red", fontSize: "130%" }} />
            </a>
          );
        }

        return null;
      },
    },
    {
      title: "İptal Dekontu",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        if (row.isCancel) {
          return (
            <a onClick={() => onClickShowReceipt(data, "cancel")}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else {
          return null;
        }
      },
    },
    {
      title: "İade Dekontu",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        if (row.isRefund || row.isPartialRefund) {
          return (
            <a onClick={() => onClickShowReceipt(data, "refund")}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else {
          return null;
        }
      },
    },
    {
      title: "Provizyon Dekontu",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        if (row.isPreAuthSuccess) {
          return (
            <a onClick={() => onClickShowReceipt(data, "provision")}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else {
          return null;
        }
      },
    },
  ].filter(Boolean);

  const renderDetailString = (text) => (text ? text : "-");
  const detailColumns = [
    {
      title: "Kart Numarası",
      dataIndex: "cardNumber",
      render: renderDetailString,
    },
    {
      title: "E-posta",
      dataIndex: "customerEmail",
      render: renderDetailString,
    },
    {
      title: "Cep Telefonu",
      dataIndex: "mobilePhone",
      render: renderDetailString,
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      render: renderDetailString,
    },
    {
      title: "İptal/İade Notu",
      dataIndex: "cancelNote",
      render: renderDetailString,
    },
    {
      title: "İade Tutarı",
      dataIndex: "refundAmount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Müşteri Bilgisi",
      dataIndex: "customerInformation",
      render: renderDetailString,
    },
    {
      title: "Kart Sahibi Adı",
      dataIndex: "holderName",
      render: renderDetailString,
    },
  ];

  if (useAdditionalInformation) {
    detailColumns.push(
      {
        title: "Sözleşme No",
        dataIndex: "contractNumber",
        render: renderDetailString,
      },
      {
        title: "Ek Alan",
        dataIndex: "memberNumber",
        render: renderDetailString,
      },
      {
        title: "TCKN",
        dataIndex: "tckn",
        render: renderDetailString,
      },
      {
        title: "Şube Adı/Kodu",
        dataIndex: "branchCode",
        render: renderDetailString,
      },
      {
        title: "Ödeme Şekli",
        dataIndex: "paymentMethod",
        render: renderDetailString,
      }
    );
  }

  if (isUseB2BCurrencyExChange) {
    detailColumns.push(
      {
        title: "TL Döviz Karşılığı",
        dataIndex: "exchangeTlAmount",
        render: (data) =>
          data === null ? "" : ColumnHelper.renderDecimal(data),
      },
      {
        title: "USD Döviz Karşılığı",
        dataIndex: "exchangeUsdAmount",
        render: (data) =>
          data === null ? "" : ColumnHelper.renderDecimal(data) + " $",
      },
      {
        title: "Euro Döviz Karşılığı",
        dataIndex: "exchangeEuroAmount",
        render: (data) =>
          data === null ? "" : ColumnHelper.renderDecimal(data) + " €",
      }
    );
  }

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> Tahsilat Geçmişi
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <PosCollectionTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
            rowClassName={(record, index) =>
              record.cancelRefundRequest == 0
                ? "table-row-yellow"
                : "table-row-default"
            }
          />
        </Col>
      </Row>

      <Modal
        id="sendReceiptModal"
        centered
        visible={sendReceiptModal.visible}
        onCancel={() => setSendReceiptModal({ visible: false, data: null })}
        footer={null}
      >
        <B2bPosCollectionSendReceiptForm
          data={sendReceiptModal.data}
          onFinish={() => setSendReceiptModal({ visible: false, data: null })}
        />
      </Modal>

      <Modal
        title="Dekont"
        width={1200}
        style={{ height: 550 }}
        visible={receiptModalVisible}
        onOk={handleOkReceipt}
        onCancel={handleCancelReceipt}
        footer={null}
      >
        <Iframe
          url={pdfUrl}
          width="100%"
          height="550px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal>

      <Modal
        id="posCollectionRefundModal"
        centered
        width={500}
        visible={posCollectionTransactionRefundModal.visible}
        onCancel={() =>
          setPosCollectionTransactionRefundModal({ visible: false, data: null })
        }
        footer={null}
        title={"İade Talebi"}
        destroyOnClose={true}
      >
        <PosCollectionTransactionRefundModal
          data={posCollectionTransactionRefundModal.data}
          onSuccess={() => {
            var data = posCollectionTransactionRefundModal.data;

            setPosCollectionTransactionRefundModal({
              visible: false,
              data: null,
            });

            if (data.cancelRefundRequest === 0) {
              refundRequestChangeStatus(data.id, 1);
            } else {
              getTableData();
            }
          }}
        />
      </Modal>

      <Modal
        id="posCollectionCancelModal"
        centered
        width={500}
        visible={posCollectionTransactionCancelModal.visible}
        onCancel={() =>
          setPosCollectionTransactionCancelModal({ visible: false, data: null })
        }
        footer={null}
        title={"İptal Talebi"}
        destroyOnClose={true}
      >
        <PosCollectionTransactionCancelModal
          data={posCollectionTransactionCancelModal.data}
          onSuccess={() => {
            var data = posCollectionTransactionCancelModal.data;

            setPosCollectionTransactionCancelModal({
              visible: false,
              data: null,
            });

            if (data.cancelRefundRequest === 0) {
              refundRequestChangeStatus(data.id, 1);
            } else {
              getTableData();
            }
          }}
        />
      </Modal>

      <Modal
        id="posCollectionTransactionCompleteProvisionModal"
        centered
        width={600}
        visible={posCollectionTransactionCompleteProvisionModal.visible}
        onCancel={() =>
          setPosCollectionTransactionCompleteProvisionModal({
            visible: false,
            data: null,
          })
        }
        footer={null}
        title={"Provizyon Kapama"}
        destroyOnClose={true}
      >
        <PosCollectionTransactionCompleteProvisionModal
          data={posCollectionTransactionCompleteProvisionModal.data}
          onSuccess={() => {
            setPosCollectionTransactionCompleteProvisionModal({
              visible: false,
              data: null,
            });
            getTableData();
          }}
        />
      </Modal>
    </>
  );
};

export default PosCollectionTransaction;
